<template>
  <el-container class="app-container">
    <el-header class="header" height="60px">
      <div class="header-inner">
        <div class="logo">
          <img src="@/assets/logo-white.png" alt="DC Fund" @error="$event.target.style.display='none'">
        </div>
        <AppHeader />
      </div>
    </el-header>
    <el-main class="content-wrapper">
      <router-view />
    </el-main>
    <el-footer id="footer" height="60px">
      <div class="footer-inner">
        <span>&copy; {{ currentYear }} {{ $t('dci asset management company limited., all rights reserved.') }}</span>
        <div class="footer-link">
          <!-- <a href="#/privacy" target="_blank">{{ $t('privacy') }}</a> -->
          <router-link to="/privacy">{{ $t('privacy') }}</router-link>
          &nbsp;|&nbsp;
          <a href="https://www.dcfund.com.hk/cn/" target="_blank">{{ $t('dc fund') }}</a>
        </div>
      </div>
    </el-footer>
    <ChangePasswordDialog />
    <StatementDialog />
  </el-container>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import ChangePasswordDialog from '@/components/ChangePasswordDialog.vue'
import StatementDialog from '@/components/StatementDialog.vue'

export default {
  name: 'App',
  components: { AppHeader, ChangePasswordDialog, StatementDialog },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
}
.footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
